enum Season {
  SPRING = "Spring",
  AUTUMN = "Autumn",
  WINTER = "Winter",
}

export default Season;
